/*
saikrishna 10/12/2022  3075154998 Print_Payload_changes,FormulaRuleGroup_payload
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/28/2022 3075154998  Added Rows per screen text in table pagination
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Dilip 11/03/2022 3075154998 Added filter group code in delete popup
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {useState, useEffect, createRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from './../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import DeleteTableRecordPopup from './../../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import {ErrorSnackbar} from './../../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import {fetchFilterGroupData} from './../../../../../redux/reducers/DMFilterGroup/index';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
export default function TriggerSearchTable({searchData, setSubmit, submit, setValue}) {
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteData, setDeleteData] = useState({});
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [status, setStatus] = useState(false);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const columns = [
    {
      title: 'Code',
      field: 'filterGroupCode',
    },
    {
      title: 'Description',
      field: 'description',
    },
    {
      title: 'Record Type',
      field: 'record_type',
    },
  ];
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const [rows, setRows] = useState(defaultRows);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);
  const handleSubmit = () => {
    httpPaginationDelete(`dmfiltergroup/delete/filtergroup/${deleteData?.filterGroupCode}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Data Manager Filter Group"
        value={`Are you sure want to delete this ${deleteData?.filterGroupCode} Filter Group Code ?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `dmfiltergroup/findall/filtergroup`;
                const bodyObj = {
                  limit: query.pageSize ? query.pageSize : null,
                  groupCode: searchData?.code ? searchData?.code?.toUpperCase() : '',
                  recordType: searchData?.recordType?.valueCode ?
                    searchData?.recordType?.valueCode :
                    '',
                  description: searchData?.description ? searchData?.description : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                // Added Add/View button in table header for routing (2700799562)
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      // disabled={dataCount === 0}
                    >
                      Add Filter Group
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setValue(1);
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  onClick: () => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            onRowClick={(event, rowData) => {
              dispatch(fetchFilterGroupData(rowData?.filterGroupCode));
              setValue(1);
            }}
          />
        </div>
      </Grid>
      {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
      {tstmsg && <SuccessSnackbar successMsg={tstmsg} />}
    </>
  );
}
